import { render, staticRenderFns } from "./SMSError.vue?vue&type=template&id=042989b0"
import script from "./SMSError.vue?vue&type=script&lang=js"
export * from "./SMSError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports